import React from 'react';

interface ChefHatIconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const ChefHatIcon: React.FC<ChefHatIconProps> = ({ className, style }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M17.5 15.5H6.5M14 12.5V15.5M6.5 14V17M17.5 14V17M17.5 12.0623C19.4937 11.6792 21 9.9255 21 7.82C21 5.43415 19.0659 3.5 16.68 3.5C16.2967 3.5 15.9251 3.54991 15.5713 3.6436C14.7801 2.64246 13.5551 2 12.18 2C10.7648 2 9.50855 2.68049 8.7206 3.73211C8.2814 3.58166 7.81025 3.5 7.32 3.5C4.93415 3.5 3 5.43415 3 7.82C3 9.9255 4.50625 11.6792 6.5 12.0623V20C6.5 20.5523 6.9477 21 7.5 21H16.5C17.0523 21 17.5 20.5523 17.5 20V12.0623Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChefHatIcon;
